export const reactionDefinitions = {
    like: {
        label: 'Like',
        emoji: '❤️',
    },

    fire: {
        label: 'Fire',
        emoji: '🔥',
    },

    funny: {
        label: 'Funny',
        emoji: '😂',
    },

    love: {
        label: 'Love',
        emoji: '😍',
    },

    rock_on: {
        label: 'Rock On',
        emoji: '🤘',
    },
};

export const buildReactionDetailsUrl = (
    baseUrl,
    reaction = null
) => {
    if (!baseUrl) {
        return '';
    }

    const url = new URL(
        baseUrl,
        window.location.origin
    );

    url.searchParams.delete(
        'reactions_page'
    );

    if (reaction) {
        url.searchParams.set(
            'reaction',
            reaction
        );
    } else {
        url.searchParams.delete(
            'reaction'
        );
    }

    return url.toString();
};